import "react-form-wizard-component/dist/style.css";
import React, {useEffect, useRef, useState, useCallback} from "react";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import CircleRow from "../components/common/circles";
import {Button, Modal, Form} from "react-bootstrap";
import DemoMTSchedulerSignupProcess from "./DemoMTSchedulerSignupProcess";
import DemoMTSchedulerLogin from "./DemoMTSchedulerLogin";
import APICom from "../utils/helpers/APICom.js";
import RoundButton from "../components/common/roundButton";
import 'bootstrap/dist/css/bootstrap.min.css';
import LaunchSimulationIcon from "../../src/assets/Images/LaunchSimulation.png";
import dropoff from "../../src/assets/Images/dropoff.png";
import pickup from "../../src/assets/Images/pickup.png";
import mapImage from "../../src/assets/Images/mapImage.jpg";
import loadingImage from "../../src/assets/Images/mainloadingnew1.jpg";
import ZoneManagment from "./ZoneManagement.js";


const MTSchedulerSimulationMain = () => {
    
    const MySimulationLink = "https://simdispatch.itcurves.us/MySimulation";
    const SimulationDashboardURL = "https://simrmdashboard.itcurves.us/login.html?username=Anonymous&password=yhUbsJ0mDGI=&webmrms=true";
    const [isLogin, setIsLogin] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [modalClass, setModalClass] = useState("");
    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [showDemoMTSchedulerLogin, setShowDemoMTSchedulerLogin] = useState(false);
    const [showZoneManagment, setZoneManagment] = useState(false);
    const [showDemoMTSchedulerSignupProcess, setShowDemoMTSchedulerSignupProcess] = useState(false);
    const timeoutId = useRef();

    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalBodyHTML, setModalBodyHTML] = useState(null);

    const xCancelSourceForGrid = useRef(null);
    xCancelSourceForGrid.current = APICom.GenerateSource();

    const [showModal, setShowModal] = useState(false);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [data, setData] = useState({
        city: 'Annapolis',
        zone: 'PURPLE',
        vehicles: '5',
        trips: '50'
    });

    const [MaxTrips, setMaxTrips] = useState({
      trips: '150',
      vehicles: '5',
  });
    const [RemainingMinutes, setRemainingMinutes] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const onLaunchSimulation = () => setShowModal(true);
    const handleShow = () => setShowModal(true);
    const handleClose = () => { 

        setErrorMessage('');
        clearTimeout(timeoutId.current);
        setShowModal(false);
    }

    const handleShowErrorPopup = () => setShowErrorPopup(true);
    const handleCloseErrorPopup = () => setShowErrorPopup(false);

    
    const whichIcon = useRef(dropoff);

    const [isVisible, setIsVisible] = useState(true);
    const [shouldAnimate, setShouldAnimate] = useState(false);
    useEffect(() => {
      const animationTimeout = setTimeout(() => setShouldAnimate(true), 2000);
      const hideTimeout = setTimeout(() => setIsVisible(false), 4000);
  
      // Cleanup timeouts if the component unmounts
      return () => {
        clearTimeout(animationTimeout);
        clearTimeout(hideTimeout);
      };
    }, []);


    // useEffect(() => {
    //   function getRandomPosition() {
    //     const containerWidth = window.innerWidth / 2; // Only the left half of the screen
    //     const containerHeight = window.innerHeight;

    //     const randomX = Math.floor(Math.random() * (containerWidth - 50)); // 50 is the width of the icon
    //     const randomY = Math.floor(Math.random() * (containerHeight - 50)); // 50 is the height of the icon

    //     return { x: randomX, y: randomY };
    //   }
  
     
    //   function createIcon() {
       
    //     if(whichIcon.current == pickup)
    //     {
    //       whichIcon.current = dropoff;
    //     }
    //     else{
    //       whichIcon.current = pickup;
    //     }
    //     const iconContainer = document.getElementById('icon-container');
    //     const icon = document.createElement('img');
    //     icon.src = whichIcon.current; // Use imported image
      
    //     icon.classList.add('icon');
  
    //     const { x, y } = getRandomPosition();
    //     icon.style.left = `${x}px`;
    //     icon.style.top = `${y}px`;
  
    //     iconContainer.appendChild(icon);
        
    //     setTimeout(() => {
    //       icon.remove(); // Remove the icon after some time if needed
    //     }, 1000); // Adjust the time before the icon disappears
    //   }
  
    //   const intervalId = setInterval(createIcon, 2000);
  
    //   // Cleanup interval on component unmount
    //   return () => clearInterval(intervalId);
    // }, []);

    const handleYes = () => {
      setShowErrorPopup(false);
      setShowModal(false);
      wrapperUpdateSessionHeartBeat()
      window.location.href = SimulationDashboardURL;
      // window.open(SimulationDashboardURL, '_blank');
    };
  
    const handleNo = () => {
      clearTimeout(timeoutId.current);
      setShowErrorPopup(false);
      setShowModal(false);
    };
        
  
    const [modalFooterHTML, setModalFooterHTML] = useState(
      <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
        OK
      </Button>
    );

    const totalSlides = 10;
    useEffect(() => {
        const timer = setInterval(() => {
            setSelectedIndex((prevIndex) => (prevIndex + 1) % totalSlides);
        }, 3000);

       
        return () => {
            console.log('TestComponent unmounted');
            clearInterval(timer);
            
        };
    }, [totalSlides]);

    const onClickDemoSimulation = async () => {

        try {
          let params = {
            "VehiclesCount": data.vehicles,
            "TripCount":data.trips
          }
            const response = await APICom.fetchData("main", "SimulationScheduler/StartDefaultSimulation", "post", {}, params, xCancelSourceForGrid.current)
    
            if (response.data['Record'] === 'NILL') {
              setRemainingMinutes(response.data['RemainingMinutes'])
              setShowErrorPopup(true)
                
            } else if (response.data['Record'] === 'I' || response.data['Record'] === 'U') {
                setShowModal(false);
                window.location.href = SimulationDashboardURL;
                // window.open(SimulationDashboardURL, '_blank');
                wrapperUpdateSessionHeartBeat()
            } else {
                setErrorMessage('An unexpected error occurred.');
            }
        } 
        
        catch (error) {
            console.error('Error starting simulation:', error);
            setErrorMessage('An error occurred while starting the simulation.');
        }

       
    }

    const onClickMySimulation = async () => {
      try {
        window.open(MySimulationLink, '_blank');
      } catch (error) {
        
      }

    }


    const onClickSignup = () => {
        try {
            setShowDemoMTSchedulerSignupProcess(true);
        } catch (error) {
            
        }
    }

    const onClickLogin = () => {
        try {
          setZoneManagment(true); 
        } catch (error) {
            
        }
    };

    const updateSessionHeartBeat = async () => {
      try {
          let data = {
              "iUserRecordID": 1
          }
              let response = await APICom.fetchData("main", "SimulationScheduler/SessionHeartBeat", "post", {}, data, xCancelSourceForGrid.current)
              if(response == undefined || response == null || response.data.result == "False"){
                  console.log("Unable to update Heart Beat.")
              }
              else{
                  wrapperUpdateSessionHeartBeat();
              }
      } catch (error) {
          updateSessionHeartBeat();
      }
  }

  const wrapperUpdateSessionHeartBeat = async () => {
      try {
          timeoutId.current = setTimeout(async () => {
              await updateSessionHeartBeat();
          }, 5000); //  5 seconds
      } catch (error) {
          
      }
  }

  const [isPaneVisible, setIsPaneVisible] = useState(true);

  const togglePane = () => {
    setIsPaneVisible(!isPaneVisible);
  };

  return (
    <div id="mainBodySimulation_" style={{fontFamily: 'Roboto, sans-serif'}}>  
      {/* <div className="appSimPane">
        <div className={`left-pane ${isPaneVisible ? 'visible' : 'hidden'}`}>
          <button onClick={togglePane} className="hide-button">
            {isPaneVisible ? 'X' : '>'}
          </button>
           Content of the pane 
          <label className="welcomemessage2">Welcome to ITCurves Microtransit Simulation This MT Simulation helps you in optimizing vehicle deployment,
                route planning, and service coverage. By analyzing different parameters and conditions,
                stakeholders can make data-driven decisions to improve service quality,
                reduce operational expenses, and enhance overall transit efficiency</label>
        </div>
         <div className="content">
          <p>Main content area</p>
        </div> 
      </div> */}
  
      {isVisible && (
          <div id="mainImageUponLoading" className={`floating-div ${shouldAnimate ? 'animate' : ''}`}>
              <img src={loadingImage} style={{boxShadow:"-2px 9px 15px -2px rgb(0, 0, 0)"}}/>
          </div>
        )}
    <div id="logodiv">

    </div>
    <div style={{ display: 'flex',justifyContent:"center", backgroundColor:"#4a4d50"}}>
    </div>
    <div style={{ display: 'flex', height:"8vh", backgroundColor:"#495f73"}}>
        <div style={{width:"116.2%"}}>
            <div className="mtsHeadercontainer_" style={{marginTop:"10px"}}>
              {/* <img id="mtsHeader"/> */}
              {/* <label className="MTLabelHeader">ITCurves Microtransit Simulation</label> */}
              <div className="line-container">
                  <div className="line line1"></div>
                  <div className="circle circle1"></div>
              </div>
              <div className="line-container">
                  <div className="line line2"></div>
                  <div className="circle circle2"></div>
              </div>
              <div className="line-container">
                  <div className="line line3"></div>
                  <div className="circle circle3"></div>
              </div>


            </div>
            <div id="welcomeMessage">
               
            </div>

        </div>
        <div className="MTSSignupDetailsbtn">
            <button className="MTSSignup"  onClick={handleShow} style={{display:"none"}}>My Simulation</button>
            {/* <button className="MTSSignup" style={{background:"darkgray"}} onClick={onClickSignup}>Signup</button> */}
            <button className="MTSSimulationBtn"  onClick={onClickLogin} style={{display:"none"}} > My Simulation</button>
            {/* <button className="MTSSignup" style={{background:"sandybrown"}}>Watch Demo</button> */}
        </div>
    </div>
    
      <div className="container_DefaultSimulation">
        <div className="left-div">
        <div id="icon-container"></div>
          <div className="typing-container2">
          
          </div>
          <div className="dashboardDesign">
            <div className="dashboardDesignInternal"></div>
          </div>
        </div>
        <div className="right-div">
          <div style={{background:"#495f73", height:"89vh", fontFamily: 'Roboto, sans-serif'}}>
              <Form style={{borderRadius: "0px"}}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', paddingLeft: "10px", paddingRight: "10px" }}>
                  <div style={{width:"100%",color:"white",textAlign:"center", marginTop:"18px"}}>
                    <h2>Microtransit Simulation in 60 Minutes</h2>
                  </div>
                  <div style={{width:"100%", background:"#818f9c"}}>
                    <Form.Group controlId="city">
                      <Form.Label style={{color:"white", marginLeft: "10px",fontSize:"16px", marginTop:"5px", fontWeight:"bold"}}>City</Form.Label>
                      <Form.Control type="text" value={data.city} style={{borderRadius: "0px",lineHeight:"2", background:"#d5d5d5", boxShadow:"4px 9px 15px 3px rgba(0, 0, 0, 0.2)"}} readOnly />
                    </Form.Group>
                  </div>
                  <div style={{width:"100%", background:"#818f9c"}}>
                    <Form.Group controlId="zone">
                      <Form.Label style={{color:"white", marginLeft: "10px",fontSize:"16px", marginTop:"5px", fontWeight:"bold"}}>Service Zone</Form.Label>
                      <Form.Control type="text" value={data.zone} style={{borderRadius: "0px",lineHeight:"2",background:"#d5d5d5", boxShadow:"4px 9px 15px 3px rgba(0, 0, 0, 0.2)"}} readOnly />
                    </Form.Group>
                  </div>
                  <div style={{width:"47%", background:"#818f9c"}}>
                    <Form.Group controlId="vehiclescount">
                      <Form.Label style={{color:"white", marginLeft: "10px",fontSize:"16px", marginTop:"5px", fontWeight:"bold"}}>Number of vehicles (Max {MaxTrips.vehicles})</Form.Label>
                      <Form.Control  type="number" value={data.vehicles} min={1} max={MaxTrips.vehicles} style={{borderRadius: "0px",lineHeight:"2", boxShadow:"4px 9px 15px 3px rgba(0, 0, 0, 0.2)"}}
                      onChange={(e) => {
                      const value = Math.max(1, Math.min(MaxTrips.vehicles, Number(e.target.value)));
                      setData({ ...data, vehicles: value })}}
                      
                      />
                    </Form.Group>
                  </div>
                  <div style={{width:"49%", background:"#818f9c"}}>
                    <Form.Group controlId="tripcount">
                      <Form.Label style={{color:"white", marginLeft: "10px",fontSize:"16px", marginTop:"5px", fontWeight:"bold"}}>No. of trips (Max {MaxTrips.trips})</Form.Label>
                      <Form.Control  style={{borderRadius: "0px", lineHeight:"2", boxShadow:"4px 9px 15px 3px rgba(0, 0, 0, 0.2)"}} 
                        type="number"
                        value={data.trips}
                        min={1}
                        max={MaxTrips.trips}
                        onChange={(e) => {
                          const value = Math.max(1, Math.min(MaxTrips.trips, Number(e.target.value)));
                          setData({ ...data, trips: value });
                       }}
                      />
                    </Form.Group>
                  </div>
                
                </div>
              </Form>
              <div style={{width:"100%"}}>
                <label className="welcomemessage2">Welcome to ITCurves Microtransit Simulation This MT Simulation helps you in optimizing vehicle deployment,
                  route planning, and service coverage. By analyzing different parameters and conditions,
                  stakeholders can make data-driven decisions to improve service quality,
                  reduce operational expenses, and enhance overall transit efficiency</label>
              </div>
              {/* <div style={{display: 'flex', justifyContent: 'center',alignItems: 'flex-end', height: '18vh' }}>
                    <RoundButton
                      imageSrc={LaunchSimulationIcon} // Replace with your image path
                      altText="Icon"
                      onClick={onClickDemoSimulation}
                    />
              </div> */}
              <div style={{display: 'flex', justifyContent: 'flex-start',alignItems: 'flex-end', height: '10vh' }}>
                      <button style={{width:"50%", background:"#bcf174"}} variant="secondary" onClick={onClickDemoSimulation} id="MySimulationRedirectioButton">
                        Start Simulation
                      </button>
                      <button style={{width:"45%"}} variant="secondary" onClick={onClickMySimulation} id="MySimulationRedirectioButton">
                        Try Custom Simulation
                      </button>
              </div>
          </div>
         
        </div>
      </div>

    <DataPopup show={showModal} handleClose={handleClose} onClickDemoSimulation = {onClickDemoSimulation} data={data} errorMessage = {errorMessage} setData = {setData} MaxTrips = {MaxTrips}/>
    <ErrorPopup show={showErrorPopup} handleYes={handleYes}  handleNo={handleNo} RemainingMinutes = {RemainingMinutes}/>

    {showZoneManagment  ? <ZoneManagment showZoneManagment={showZoneManagment} setZoneManagment={setZoneManagment}/> : ""}
     {showDemoMTSchedulerLogin  ? <DemoMTSchedulerLogin showDemoMTSchedulerLogin={showDemoMTSchedulerLogin} setShowDemoMTSchedulerLogin={setShowDemoMTSchedulerLogin}/> : ""}
     {showDemoMTSchedulerSignupProcess  ? <DemoMTSchedulerSignupProcess showDemoMTSchedulerSignupProcess={showDemoMTSchedulerSignupProcess} setShowDemoMTSchedulerSignupProcess={setShowDemoMTSchedulerSignupProcess}/> : ""}
   

   </div>
  );
}

export default MTSchedulerSimulationMain;

function ErrorPopup({ show, handleYes, handleNo, RemainingMinutes }) {
  return (
    <Modal show={show} onHide={handleNo} centered>
      <Modal.Header closeButton  style={{background:"#485f73", color:"white"}}>
        <Modal.Title>No Slot Available</Modal.Title>
      </Modal.Header>
      <Modal.Body  style={{background:"#485f73", color:"white"}}>
      <p style={{padding:'5px', background: '#ff000017', fontWeight: 'bold'}}>Another user is watching the simulation. Please wait until {RemainingMinutes}</p>
      <p>Or Would you like to join the running simulation?</p>
      </Modal.Body>
      <Modal.Footer  style={{background:"#485f73", color:"white"}}>
        <Button variant="secondary" onClick={handleNo}>
          No
        </Button>
        <Button style={{ background: "lightgreen", color:"black"}} variant="primary" onClick={handleYes}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}


function DataPopup({ show, handleClose, data, onClickDemoSimulation, errorMessage, setData , MaxTrips}) {
    return (
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton style={{background:"#485f73", color:"white"}}>
          <Modal.Title>Microtransit Simulation in 30 Minutes</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{background:"#485f73", color:"white"}}>
        {errorMessage && (
          <span style={{ color: 'red', display: 'block', marginBottom: '1rem' }}>
            {errorMessage}
          </span>
        )}
          <Form>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
              <div >
                <Form.Group controlId="city">
                  <Form.Label>City</Form.Label>
                  <Form.Control type="text" value={data.city} readOnly style={{ backgroundColor: "#e9ecef", color: "#495057" }} />
                </Form.Group>
              </div>
              <div >
                <Form.Group controlId="zone">
                  <Form.Label>Zone</Form.Label>
                  <Form.Control type="text" value={data.zone} readOnly style={{ backgroundColor: "#e9ecef", color: "#495057" }} />
                </Form.Group>
              </div>
              <div>
                <Form.Group controlId="vehiclescount">
                  <Form.Label>Number of vehicles (Max {MaxTrips.vehicles})</Form.Label>
                  <Form.Control
                    type="number"
                    value={data.vehicles}
                    min={1}
                    max={MaxTrips.vehicles}
                    onChange={(e) => {
                      const value = Math.max(1, Math.min(MaxTrips.vehicles, Number(e.target.value)));
                      setData({ ...data, vehicles: value });
                    }}
                  />
                </Form.Group>
              </div>
              <div>
              <Form.Group controlId="tripcount">
                <Form.Label>Number of trips per hour (Max {MaxTrips.trips})</Form.Label>
                <Form.Control
                  type="number"
                  value={data.trips}
                  min={1}
                  max={MaxTrips.trips}
                  onChange={(e) => {
                    const value = Math.max(1, Math.min(MaxTrips.trips, Number(e.target.value)));
                    setData({ ...data, trips: value });
                  }}
                />
              </Form.Group>
              </div>
             
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{background:"#485f73", color:"white"}}>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button style={{ background: "lightgreen", color:"black"}} variant="primary" onClick={onClickDemoSimulation}>
            Continue
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
